import { render, staticRenderFns } from "./dashboard_pie.vue?vue&type=template&id=1ea5b487"
import script from "./dashboard_pie.vue?vue&type=script&lang=js"
export * from "./dashboard_pie.vue?vue&type=script&lang=js"
import style0 from "./dashboard_pie.vue?vue&type=style&index=0&id=1ea5b487&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports